<template>
  <v-card flat>
    <v-card-text class="pa-0 ma-0" v-if="infoWindowItem">
      <div class="text-caption">
        <div class="text-subtitle-2">
          <router-link target="_blank" :to="`/${options.url}/${infoWindowItem[options.id]}`">
            <div v-for="(item, idx) in infoWindowItemsConfig" :key="idx">
              <v-chip
                v-if="infoWindowItem[item.id]"
                :class="item.id == 'DeviceID' ? 'vtred--text bold' : ''"
                label
                x-small
              >
                <v-icon left x-small> {{ item.icon }} </v-icon>
                {{ item.phase ? `${item.phase}:` : null }}
                {{
                  typeof infoWindowItem[item.id] === "number"
                    ? infoWindowItem[item.id].toFixed(2)
                    : infoWindowItem[item.id]
                }}
                <div v-if="item.suffix" class="pl-1">{{ item.suffix }}</div>
              </v-chip>
            </div>
          </router-link>
        </div>
        <div class="mt-2">
          <div v-for="(key, index) in issues" :key="`${index}_issue`" class="text-caption">
            <v-icon class="mr-4" color="vtred" v-if="infoWindowItem[key]" small>{{
              page_config.issues[key].icon
            }}</v-icon
            >{{ infoWindowItem[key] ? page_config.issues[key].label : "" }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MapInfoWindowPowerdataTemplate",
  components: {},
  props: { infoWindowItem: Object, options: Object, infoWindowItemsConfig: Array },
  data: function () {
    return {};
  },
  methods: {},
  created() {
    this.page_config = this.$config;
  },
  computed: {
    issues: function () {
      return Object.keys(this.page_config.issues);
    },
  },
};
</script>
<style lang="scss" scoped></style>
